<template>
  <svg
    id="Group_899"
    data-name="Group 899"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="19.667"
    height="19.654"
    viewBox="0 0 19.667 19.654"
  >
    <defs>
      <clipPath id="link-svg">
        <rect
          id="Rectangle_2829"
          data-name="Rectangle 2829"
          width="19.667"
          height="19.654"
          fill="#bbb"
        />
      </clipPath>
    </defs>
    <g
      id="Group_899-2"
      data-name="Group 899"
      clip-path="url(#link-svg)"
    >
      <path
        id="Path_276"
        data-name="Path 276"
        d="M0,53.847v-.1a2.929,2.929,0,0,1,.76-1.771,2.7,2.7,0,0,1,1.484-.834,2.764,2.764,0,0,1,.507-.055q2.1-.013,4.21-.014a1.4,1.4,0,0,1,1.29.724,1.281,1.281,0,0,1,.165.564,1.357,1.357,0,0,1-.7,1.333,1.511,1.511,0,0,1-.814.188l-3.683-.007H2.831l-.014.01c0,.025,0,.05,0,.075q0,5.533,0,11.066v.091H14.061c0-.016,0-.033,0-.051q0-2.055,0-4.109a1.376,1.376,0,0,1,.837-1.328,1.315,1.315,0,0,1,.8-.1,1.4,1.4,0,0,1,1.146,1.2,2.086,2.086,0,0,1,.017.251c0,1.326,0,2.653,0,3.979a3.039,3.039,0,0,1-.183,1.136,2.785,2.785,0,0,1-2.086,1.774,3.938,3.938,0,0,1-.432.05l-.219,0H2.759l-.055,0A2.812,2.812,0,0,1,.136,65.944a2.434,2.434,0,0,1-.12-.784c0-.062,0-.123,0-.185,0-.023,0-.046,0-.068q0-5.455,0-10.909c0-.023,0-.046,0-.068L0,53.847"
        transform="translate(0 -48.273)"
        fill="#bbb"
      />
      <path
        id="Path_277"
        data-name="Path 277"
        d="M116.535,1.3c0,.041,0,.082,0,.123q0,3.507,0,7.013c0,.023,0,.046,0,.068a1.391,1.391,0,0,1-.738,1.144,1.351,1.351,0,0,1-.524.16,1.4,1.4,0,0,1-1.489-1.051,1.8,1.8,0,0,1-.049-.388c0-1.146,0-2.291,0-3.437V4.789a.565.565,0,0,0-.046.036c-.559.563-1.115,1.129-1.676,1.69q-3.212,3.216-6.426,6.429c-.228.228-.46.451-.691.675a1.381,1.381,0,0,1-.818.4,1.359,1.359,0,0,1-1.349-.63,1.294,1.294,0,0,1-.229-.867,1.389,1.389,0,0,1,.4-.87c.47-.475.943-.946,1.415-1.418l7.276-7.276c.048-.048.1-.094.145-.141l-.009-.021h-.063c-1.18,0-2.36,0-3.54,0a1.425,1.425,0,0,1-1.365-1.043,1.4,1.4,0,0,1,1.11-1.738c.051-.009.1-.013.154-.019l.185,0h6.945l.061,0a1.4,1.4,0,0,1,1.266,1.012,2.948,2.948,0,0,1,.053.293"
        transform="translate(-96.868 0.001)"
        fill="#bbb"
      />
    </g>
  </svg>
</template>
<script setup lang="ts">
import IconProps from '@/assets/ts/interfaces/IconProps'

withDefaults( defineProps<IconProps>(), {} )
</script>